"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkEventHandler = void 0;
var helpers_1 = require("../../../helpers");
var LinkEventHandler = /** @class */ (function () {
    function LinkEventHandler() {
    }
    LinkEventHandler.prototype.normalizeHref = function (href) {
        return helpers_1.RouterHelper.normalizeHref(href);
    };
    LinkEventHandler.prototype.onClickLinkEventHandler = function (event) {
        helpers_1.RouterHelper.onClickLinkEventHandler(event);
    };
    return LinkEventHandler;
}());
exports.LinkEventHandler = LinkEventHandler;
